<script>
    import { CONSTANTS } from '../utils/constant';

    export let category;

    const {
        CATEGORY_4PLAY,
        CATEGORY_TRIPLEPLAY,
        CATEGORY_TRIPLEPLAY_MOVIL,
        CATEGORY_RESIDENCIAL,
        CATEGORY_TV,
        CATEGORY_MOVIL,
    } = CONSTANTS;
    let separatorName = '';

    if (category === CATEGORY_4PLAY) {
        separatorName = 'separator_4p';
    } else if (category === CATEGORY_TRIPLEPLAY) {
        separatorName = 'separator_3p_tv';
    } else if (category === CATEGORY_TRIPLEPLAY_MOVIL) {
        separatorName = 'separator_3p_movil';
    } else if (category === CATEGORY_RESIDENCIAL) {
        separatorName = 'separator_2p';
    } else if (category === CATEGORY_TV) {
        separatorName = 'separator_1p_tv';
    } else if (category === CATEGORY_MOVIL) {
        separatorName = 'separator_1p_movil';
    } else {
        separatorName = 'separator_negocios';
    }
</script>

<svg aria-hidden="true" class="plan-card__separator"
    ><use
        xlink:href="/assets/img/icons/izzi-separator-defs.svg#{separatorName}"
    /></svg
>
